var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M110.2 37l-19-17.4H34c-2 0-3.7 1.6-3.7 3.7V118c0 2 1.6 3.7 3.7 3.7h72.6c2 0 3.7-1.6 3.7-3.7v-5.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M91.3 19.7V37h18.9M109.7 103H46.3c-2.8 0-5.1-2.3-5.1-5.1V51.2c0-2.8 2.3-5.1 5.1-5.1h63.4c2.8 0 5.1 2.3 5.1 5.1v46.6c0 2.9-2.3 5.2-5.1 5.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M48.6 92.7l18.6-32.9 19 32.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M82.5 86.3l10.4-11.4 12.3 15.2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "DI_4L_main",
    cx: 98.8,
    cy: 59.8,
    r: 6.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M58.6 74.9l4.1 7.6 5-6.2 4 4.5 4.3-5.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.a50c1511876de709ffc327c4390e75a4.svg";
export { ForwardRef as ReactComponent };